<template>
    <v-container
            class="fill-height"
            fluid
    >
        <v-row
                align="center"
                justify="end"
        >
            <v-col
                    cols="12"
                    sm="8"
                    md="4"
            >
                <v-card class="elevation-12">
                    <v-card-text>


                        <v-container>
                            <v-row class="header-image-container">
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-img
                                            src="./../assets/logo.jpg"
                                            lazy-src="./../assets/logo.jpg"
                                            class="grey lighten-2"
                                            max-width="250"
                                    ></v-img>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <p class="text-justify font-weight-bold">
                                        {{ $t('requestPasswordResetSuccess.header', {
                                            email: $route.params.email
                                        }) }}
                                    </p>
                                    <p class="text-justify">
                                        {{ $t('requestPasswordResetSuccess.text') }}
                                    </p>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: 'RequestPasswordResetSuccess'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .header-image-container {
        height: 75px;
    }
</style>
